<script lang="ts">
	import { globals } from '$lib/Globals';
	import type { GenreDataType } from '$lib/types/GenreData';

	const { selectedGenres = $bindable([]) }: { selectedGenres: GenreDataType[] } = $props();

	function toggleGenre(genre: GenreDataType) {
		if (selectedGenres.some((g) => g.id === genre.id)) {
			const index = selectedGenres.findIndex((g) => g.id === genre.id);
			selectedGenres.splice(index, 1);
		} else {
			selectedGenres.push(genre);
			selectedGenres.sort((a, b) => a.position - b.position);
		}
	}
</script>

<section>
	{#each globals.data.genres as genre}
		<button
			class="button:outline no-icon"
			aria-pressed={selectedGenres.some((g) => g.id === genre.id)}
			onclick={() => toggleGenre(genre)}>{genre.name}</button
		>
	{/each}
</section>

<style lang="scss">
	section {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: $gap3;
		padding: $gap6 var(--gutter);

		@include md {
			padding: $gap7 var(--gutter);
		}

		@include lg {
			padding-left: calc(cols(12, 1, true, true) + (var(--gutter) - var(--gap)));
			padding-right: calc(cols(12, 1, true, true) + (var(--gutter) - var(--gap)));
		}
	}
</style>
